// @flow
import React from 'react'
import { format } from 'date-fns'
import es from 'date-fns/locale/es'
import ca from 'date-fns/locale/ca'
import i18n from 'i18next'
import { Wrapper } from './styles'

type Props = {
  date: string,
  language: string
}

const DeliveryEstimated = (props: Props) => {
  return (
    <Wrapper>
      <p>
        <strong>{i18n.t('checkout.expectedDelivery')}</strong>:{' '}
        {i18n.t('checkout.deliveryPrevision', {
          day: format(props.date, 'dddd', {
            locale: props.language === 'es' ? es : ca
          }),
          dayDate: format(props.date, 'D'),
          month: format(props.date, 'MMMM', {
            locale: props.language === 'es' ? es : ca
          })
        })}
      </p>
    </Wrapper>
  )
}

export default DeliveryEstimated
